import { createCompoundContext } from '@/lib/context';

export const { CompoundProvider, useCompoundContext } = createCompoundContext<{
  hideDesktopNav: boolean;
}>('Header');
